import moment from 'moment-timezone'

import { dateFormat } from 'app/common/ui-next/plain-date-period'

/**
 * Дефолтный период фильтра: [начало текущего месяца, сегодня] в формате DD.MM.YYYY
 */
export function calcDefaultPeriod(): [string, string] {
  const today = moment()
  return [today.clone().startOf('month').format(dateFormat), today.format(dateFormat)]
}
